import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskEmail'
})
export class MaskEmailPipe implements PipeTransform {

  transform(email: string): string {
    if (!email) return email;

    const atIndex = email.indexOf('@');
    if (atIndex <= 1) return email;

    const firstChar = email[0];
    const lastBeforeAt = email[atIndex - 1];
    const domain = email.substring(atIndex);

    return `${firstChar}***${lastBeforeAt}${domain}`;
  }

}
